import { Component, NgZone, ViewChild, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import {
  FormGroup,
  FormControl,
  FormArray,
  Validators,
  Form,
} from '@angular/forms';
import { IOption } from 'src/app/interfaces/option';
import { SiteService } from 'src/app/services/site.service';
import { CdkTextareaAutosize } from '@angular/cdk/text-field';
import { take } from 'rxjs/operators';

import Swal from 'sweetalert2/dist/sweetalert2.js';
import { AppFormat } from '../../appFormat';

import { OperadorService } from '../../services/operador.service';

import {
  faFacebookF,
  faInstagram,
  faTwitter,
  faYoutube,
  faVimeo,
  faPinterest,
} from '@fortawesome/free-brands-svg-icons';

@Component({
  selector: 'app-parameters',
  templateUrl: './parameters.component.html',
  styleUrls: ['./parameters.component.scss'],
  host: { class: 'wrapper-settings' },
})
export class ParametersComponent implements OnInit {
  @ViewChild('autosize') autosize!: CdkTextareaAutosize;

  public loading: boolean = false;

  public changed: boolean;
  public settingsFrm: FormGroup;

  public networksocial!: FormArray;
  public networksocials: any[] = [];

  // padrao
  public title!: FormControl;
  public keywords!: FormControl;
  public description!: FormControl;

  // configuração
  public nr_product_page!: FormControl;
  public nr_product_recommended!: FormControl;
  public nr_offers!: FormControl;

  public chat_whatsapp!: FormControl;
  public text_offers!: FormControl;
  public text_department!: FormControl;
  public text_delivery!: FormControl;
  public text_delivery_description!: FormControl;
  public text_drivethru!: FormControl;
  public text_drivethru_description!: FormControl;

  public show_brands!: FormControl;
  public menu_fixed!: FormControl;
  public dynamic_price!: FormControl;
  public warning_cookies!: FormControl;
  public warning_drinking!: FormControl;
  public warning_cookies_message!: FormControl;

  public mostra_estoque!: FormControl;

  //scripts
  public analytics_code!: FormControl;
  public code_header!: FormControl;
  public code_body!: FormControl;

  public ck: FormControl;

  constructor(
    private router: Router,
    private _ngZone: NgZone,
    private _siteService: SiteService,
    private _operadorService: OperadorService
  ) {
    let operador = this._operadorService.getOperador();
    let isMatriz = false;
    if (operador.estabelecimento) {
      isMatriz = operador.estabelecimento['matriz'] == 'S';
      if (!isMatriz) {
        this.router.navigate(['/']);
      }
    }

    this.networksocials.push({
      text: 'Facebook',
      value: 'facebook-f',
      fa: faFacebookF,
    });
    this.networksocials.push({
      text: 'Instagram',
      value: 'instagram',
      fa: faInstagram,
    });
    this.networksocials.push({
      text: 'Twitter',
      value: 'twitter',
      fa: faTwitter,
    });
    this.networksocials.push({
      text: 'Youtube',
      value: 'youtube',
      fa: faYoutube,
    });
    this.networksocials.push({ text: 'Vimeo', value: 'vimeo', fa: faVimeo });
    //this.networksocials.push({ text: 'tiktok', value: 'tiktok', fa: null });
    this.networksocials.push({
      text: 'pinterest',
      value: 'pinterest',
      fa: faPinterest,
    });
  }

  ngOnInit(): void {
    this.createFormControls();
    this.createForm();

    this.getParametersCondig();
  }

  triggerResize() {
    this._ngZone.onStable
      .pipe(take(1))
      .subscribe(() => this.autosize.resizeToFitContent(true));
  }

  createFormControls() {
    this.networksocial = new FormArray([]);

    // padrao
    this.title = new FormControl('', [Validators.required]);
    this.keywords = new FormControl('');
    this.description = new FormControl('');

    // configuração
    this.nr_product_page = new FormControl(16);
    this.nr_product_recommended = new FormControl(10);
    this.nr_offers = new FormControl(15);

    this.chat_whatsapp = new FormControl('');
    this.text_offers = new FormControl('Ofertas');
    this.text_department = new FormControl('Departamentos');
    this.text_delivery = new FormControl('Delivery');
    this.text_delivery_description = new FormControl('');
    this.text_drivethru = new FormControl('Drive Thru');
    this.text_drivethru_description = new FormControl('');

    this.show_brands = new FormControl(true);
    this.menu_fixed = new FormControl(true);
    this.dynamic_price = new FormControl(false);
    this.warning_cookies = new FormControl(true);
    this.warning_drinking = new FormControl(false);
    this.warning_cookies_message = new FormControl('');
    this.mostra_estoque = new FormControl(true);

    //scripts
    this.analytics_code = new FormControl('');
    this.code_header = new FormControl('');
    this.code_body = new FormControl('');
  }

  createForm() {
    this.settingsFrm = new FormGroup({
      title: this.title,
      keywords: this.keywords,
      description: this.description,
      nr_product_page: this.nr_product_page,
      nr_product_recommended: this.nr_product_recommended,
      nr_offers: this.nr_offers,
      chat_whatsapp: this.chat_whatsapp,
      text_offers: this.text_offers,
      text_department: this.text_department,
      text_delivery: this.text_delivery,
      text_delivery_description: this.text_delivery_description,
      text_drivethru: this.text_drivethru,
      text_drivethru_description: this.text_drivethru_description,
      show_brands: this.show_brands,
      menu_fixed: this.menu_fixed,
      dynamic_price: this.dynamic_price,
      warning_cookies: this.warning_cookies,
      warning_drinking: this.warning_drinking,
      warning_cookies_message: this.warning_cookies_message,
      analytics_code: this.analytics_code,
      code_header: this.code_header,
      code_body: this.code_body,
      networksocial: this.networksocial,
      mostra_estoque: this.mostra_estoque,
    });
  }

  onChangeDetail() {
    this.changed = true;
  }

  getParametersCondig() {
    this.loading = true;
    this._siteService.getParameters().subscribe((res) => {
      this.resParameters(res);
      this._siteService.getsocialNetwork().subscribe((res) => {
        this.resNetworkSocial(res);
      });
    });
  }

  resParameters(res) {
    this.title.setValue(res.title);
    this.keywords.setValue(res.keywords);
    this.description.setValue(res.description);
    this.nr_product_page.setValue(res.nr_product_page);
    this.nr_product_recommended.setValue(res.nr_product_recommended);
    this.nr_offers.setValue(res.nr_offers);
    this.chat_whatsapp.setValue(res.chat_whatsapp);
    this.text_offers.setValue(res.text_offers);
    this.text_department.setValue(res.text_department);
    this.text_delivery.setValue(res.text_delivery);
    this.text_delivery_description.setValue(res.text_delivery_description);
    this.text_drivethru.setValue(res.text_drivethru);
    this.text_drivethru_description.setValue(res.text_drivethru_description);
    this.show_brands.setValue(res.show_brands == 'S');
    this.menu_fixed.setValue(res.menu_fixed == 'S');
    this.dynamic_price.setValue(res.dynamic_price == 'S');
    this.warning_cookies.setValue(res.warning_cookies == 'S');
    this.warning_drinking.setValue(res.warning_drinking == 'S');
    this.mostra_estoque.setValue(res.show_stock == 'S');
    this.warning_cookies_message.setValue(res.warning_cookies_message);
    this.analytics_code.setValue(res.analytics_code);
    this.code_header.setValue(res.code_header);
    this.code_body.setValue(res.code_body);
  }

  resNetworkSocial(res) {
    if (res.social_networks) {
      this.networksocial.clear();
      for (let i in res.social_networks) {
        this.onAddNewNetworkSocial(res.social_networks[i]);
      }
    }
    this.loading = false;
  }

  onRemoveNetworkSocial(i) {
    Swal.fire({
      title: 'Você deseja remover esta rede social?',
      icon: 'warning',
      showCancelButton: true,
      confirmButtonColor: '#3085d6',
      cancelButtonColor: '#d33',
      confirmButtonText: 'Sim, desejo!',
      heightAuto: false,
    }).then((result) => {
      if (result.value) {
        let fGroup = <FormGroup>this.networksocial.controls[i];
        let social = <FormControl>fGroup.controls.social;

        social.setValue(-1);
        this.onChangeDetail();
      }
    });
  }

  onAddNewNetworkSocial(obj) {
    this.networksocial.push(
      new FormGroup({
        id: new FormControl(obj != undefined && obj.id ? obj.id : null),
        social: new FormControl(
          obj != undefined && obj.social ? obj.social : null
        ),
        url: new FormControl(obj != undefined && obj.url ? obj.url : null),
      })
    );
  }

  onCancel() {
    Swal.fire({
      title: 'Você deseja cancelar?',
      icon: 'warning',
      showCancelButton: true,
      confirmButtonColor: '#3085d6',
      cancelButtonColor: '#d33',
      confirmButtonText: 'Sim, desejo!',
    }).then((result) => {
      if (result.value) {
        this.loading = true;
        this.changed = false;
        this.getParametersCondig();
      }
    });
  }

  saveError() {
    Swal.fire('Ops!', 'Ocorreu um erro ao tentar salvar.', 'error');
  }

  saveComplete() {
    Swal.fire('Salvo!', 'Os parâmetros do site foram salvos', 'success');
  }

  saving() {
    Swal.fire({
      title: 'Salvando...',
      icon: 'info',
      showCancelButton: false,
      allowOutsideClick: false,
      showConfirmButton: false,
    });
  }

  onSubmit() {
    this.saving();

    let data = {
      title: this.title.value,
      keywords: this.keywords.value,
      description: this.description.value,
      nr_product_page: this.nr_product_page.value,
      nr_product_recommended: this.nr_product_recommended.value,
      nr_offers: this.nr_offers.value,
      chat_whatsapp: this.chat_whatsapp.value,
      text_offers: this.text_offers.value,
      text_department: this.text_department.value,
      text_delivery: this.text_delivery.value,
      text_delivery_description: this.text_delivery_description.value,
      text_drivethru: this.text_drivethru.value,
      text_drivethru_description: this.text_drivethru_description.value,
      show_brands: this.show_brands.value ? 'S' : 'N',
      menu_fixed: this.menu_fixed.value ? 'S' : 'N',
      dynamic_price: this.dynamic_price.value ? 'S' : 'N',
      warning_cookies: this.warning_cookies.value ? 'S' : 'N',
      warning_drinking: this.warning_drinking.value ? 'S' : 'N',
      show_stock: this.mostra_estoque.value ? 'S' : 'N',
      warning_cookies_message: this.warning_cookies_message.value,
      analytics_code: this.analytics_code.value,
      code_header: this.code_header.value,
      code_body: this.code_body.value,
    };

    this._siteService.storeParameters(data).subscribe((res) => {
      if (res['success']) {
        //
        this.resParameters(res);
        //
        let social_networks = [];

        for (let i in this.networksocial.controls) {
          let fGroup = <FormGroup>this.networksocial.controls[i];

          let id = <FormControl>fGroup.controls.id;
          let social = <FormControl>fGroup.controls.social;
          let url = <FormControl>fGroup.controls.url;

          if (social.value != null && social.value != '') {
            social_networks.push([id.value, social.value, url.value]);
          }
        }

        let data = {
          social_networks: social_networks,
        };

        if (social_networks.length > 0) {
          this._siteService.storesocialNetwork(data).subscribe((res) => {
            this.resNetworkSocial(res);
            //
            this.changed = false;
            //
            this.saveComplete();
          });
        } else {
          //
          this.changed = false;
          //
          this.saveComplete();
        }
      } else {
        this.saveError();
      }
    });

    return null;
  }
}
